import dayjs from "dayjs";
import validate from "validate.js";
import { format, maxLength, presence, range, regExpInvalidCharPattern, ValidationField, Validator } from "~/extensions/utils";
import { KeyReturnNameKb } from "~/extensions/utils/DefineTypes";
import { commonStore } from "~/store/CommonStore";
export class KaiyakuEntryPageValidator extends Validator {
    constructor(vm, kaiyakuForInput) {
        const constraints = {
            keyReturnStrYmd: {
                presence: presence(false, commonStore.messages.PV0001),
                kaiyakuKeyReturnYmdFormatKojin: kaiyakuKeyReturnYmdFormatKojin(vm, commonStore.messages.PV0005),
                kaiyakuKeyReturnYmdRangeKojin: kaiyakuKeyReturnYmdRangeKojin(vm, kaiyakuForInput, commonStore.messages.PV0027, commonStore.messages.PV0019)
            },
            numberOfReturnKeys: {
                numberOfReturnKeysPresence: numberOfReturnKeysPresence(vm, kaiyakuForInput, commonStore.messages.PV0001),
                numberOfReturnKeysRangeKojin: numberOfReturnKeysRangeKojin(vm, kaiyakuForInput, 0, 99)
            },
            taikyoTachiaiKb: {
                taikyoTachiaiKbPresence: taikyoTachiaiKbPresence(vm, kaiyakuForInput, commonStore.messages.PV0002),
            },
            taikyoTachiaiName: {
                taikyoTachiaiNamePresence: taikyoTachiaiNamePresence(vm, kaiyakuForInput, commonStore.messages.PV0001),
                taikyoTachiaiNameFormatKojin: taikyoTachiaiNameFormatKojin(vm, kaiyakuForInput),
                taikyoTachiaiNameMaxLengthKojin: taikyoTachiaiNameMaxLengthKojin(vm, kaiyakuForInput, 30)
            },
            postCode: {
                presence: presence(false, commonStore.messages.PV0001),
                format: format({ pattern: new RegExp("^[0-9]{3}-?[0-9]{4}$"), message: commonStore.messages.PV0014 })
            },
            adr1: {
                presence: presence(false, commonStore.messages.PV0001),
                format: regExpInvalidCharPattern,
                length: maxLength(20)
            },
            adr2: {
                format: regExpInvalidCharPattern,
                length: maxLength(20)
            },
            adr3: {
                format: regExpInvalidCharPattern,
                length: maxLength(20)
            },
            henkinBankName: {
                presence: presence(false, commonStore.messages.PV0002)
            },
            henkinBansName: {
                presence: presence(false, commonStore.messages.PV0002)
            },
            henkinKouzaSb: {
                presence: presence(false, commonStore.messages.PV0002)
            },
            henkinKouzaNo: {
                presence: presence(false, commonStore.messages.PV0001),
                henkinKouzaNoFormat: henkinKouzaNoFormat(vm, commonStore.messages.PV0018, commonStore.messages.PV0025)
            },
            henkinKouzaName: {
                presence: presence(false, commonStore.messages.PV0001),
                format: regExpInvalidCharPattern,
                length: maxLength(24)
            },
            henkinKouzaKana: {
                presence: presence(false, commonStore.messages.PV0001),
                format: format({ pattern: new RegExp("^[ｦ-ﾟ A-Z0-9().,-/¥｢｣]+$"), message: commonStore.messages.PV0024 }),
                length: maxLength(48)
            }
        };
        super(vm.model, constraints);
        this.keyReturnStrYmd = new ValidationField("keyReturnStrYmd", this.data, constraints);
        this.taikyoTachiaiKb = new ValidationField("taikyoTachiaiKb", this.data, constraints);
        this.taikyoTachiaiName = new ValidationField("taikyoTachiaiName", this.data, constraints);
        this.numberOfReturnKeys = new ValidationField("numberOfReturnKeys", this.data, constraints);
        this.postCode = new ValidationField("postCode", this.data, constraints);
        this.adr1 = new ValidationField("adr1", this.data, constraints);
        this.adr2 = new ValidationField("adr2", this.data, constraints);
        this.adr3 = new ValidationField("adr3", this.data, constraints);
        this.henkinBankName = new ValidationField("henkinBankName", this.data, constraints);
        this.henkinBansName = new ValidationField("henkinBansName", this.data, constraints);
        this.henkinKouzaSb = new ValidationField("henkinKouzaSb", this.data, constraints);
        this.henkinKouzaNo = new ValidationField("henkinKouzaNo", this.data, constraints);
        this.henkinKouzaName = new ValidationField("henkinKouzaName", this.data, constraints);
        this.henkinKouzaKana = new ValidationField("henkinKouzaKana", this.data, constraints);
        this.remarks = new ValidationField("remarks", this.data, constraints);
    }
    keyReturnStrYmd;
    taikyoTachiaiKb;
    taikyoTachiaiName;
    numberOfReturnKeys;
    postCode;
    adr1;
    adr2;
    adr3;
    henkinBankName;
    henkinBansName;
    henkinKouzaSb;
    henkinKouzaNo;
    henkinKouzaName;
    henkinKouzaKana;
    remarks;
}
export class KaiyakuEntryHasonPageValidator extends Validator {
    constructor(vm) {
        const constraints = {
            hasonInfo: {
                hasonInfoValidate: hasonInfoValidate(vm, commonStore.messages.PV0001)
            },
            remarks: {
                format: regExpInvalidCharPattern,
                length: maxLength(500)
            }
        };
        super(vm, constraints);
        this.hasonInfo = new ValidationField("hasonInfo", this.data, constraints);
        this.remarks = new ValidationField("remarks", this.data, constraints);
    }
    hasonInfo;
    remarks;
    /**
     * 特定のカードにエラーがあるかチェック
     */
    hasCardError(hason) {
        if (!hason.isSelected) {
            return false;
        }
        if (this.data.sKeiyakuKb === 0) {
            const anyChecked = hason.checkedArray.some((check) => check.isChecked);
            return !anyChecked;
        }
        return false;
    }
}
/** 鍵渡予定日のdatetime of dateフォーマットチェック */
validate.validators.kaiyakuKeyReturnYmdFormatKojin = function (value, options, key, attributes) {
    if (value === undefined || value === null || value === "") {
        return null;
    }
    // YYYY/MM/DD または YYYY/M/D のみ許可
    // YYYY-MM-DD は許可しない
    const dateFormatPattern = /^([12]\d{3})\/(0?[1-9]|1[0-2])\/(0?[1-9]|[12]\d|3[01])$/;
    if (!dateFormatPattern.test(value)) {
        return options.message;
    }
    // 実在する日付かチェック
    const [year, month, day] = value.split("/").map(Number);
    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day) {
        return options.message;
    }
    return null;
};
export function kaiyakuKeyReturnYmdFormatKojin(vm, message) {
    return {
        vm: vm,
        message: message
    };
}
/** 鍵渡予定日に応じた鍵返却予定日時範囲チェック */
validate.validators.kaiyakuKeyReturnYmdRangeKojin = function (value, options, key, attributes) {
    if (value === undefined || value === null || value === "") {
        return commonStore.messages.PV0001;
    }
    const keyReturnNameKb = options.kaiyakuForInput?.keyReturnNameKb;
    const dateFormatKeyReturnNameKbs = [
        KeyReturnNameKb.PreferredAttendanceDatetime,
        KeyReturnNameKb.KeyReturnScheduledDatetime
    ];
    // 入力された日付
    const targetDate = dayjs(value, ["YYYY/M/D", "YYYY/MM/DD"], true);
    // フォーマットチェック側でエラーになるため、
    // ここでは範囲チェックを行わない
    if (!targetDate.isValid()) {
        return null;
    }
    const targetDay = targetDate.startOf("day");
    const today = dayjs().startOf("day");
    const kaiyakuDay = dayjs(options.vm.model.kaiyakuYmd).startOf("day");
    // 今日より前
    if (targetDay.isBefore(today)) {
        return options.isBeforeTodayMessage;
    }
    // 解約日より後
    if (targetDay.isAfter(kaiyakuDay)) {
        return options.isAfterKaiyakuYmdMessage;
    }
    if (dateFormatKeyReturnNameKbs.includes(keyReturnNameKb)) {
        const keyReturnStrTime = options.vm.model.keyReturnStrTime;
        if (!keyReturnStrTime) {
            return null;
        }
        const timePattern = /^([01]\d|2[0-3]):[0-5]\d$/;
        if (!timePattern.test(keyReturnStrTime)) {
            return null;
        }
        const targetDatetime = dayjs(`${value} ${keyReturnStrTime}`, ["YYYY/M/D HH:mm", "YYYY/MM/DD HH:mm"], true);
        if (!targetDatetime.isValid()) {
            return null;
        }
        const keyReturnMinTime = options.kaiyakuForInput?.keyReturnMinTime;
        const keyReturnMaxTime = options.kaiyakuForInput?.keyReturnMaxTime;
        if (!keyReturnMinTime || !keyReturnMaxTime) {
            return null;
        }
        const [minHour, minMinute] = keyReturnMinTime.split(":").map(Number);
        const [maxHour, maxMinute] = keyReturnMaxTime.split(":").map(Number);
        const openTime = targetDay
            .hour(minHour)
            .minute(minMinute)
            .second(0);
        const closeTime = targetDay
            .hour(maxHour)
            .minute(maxMinute)
            .second(0);
        const msgOutOfRange = `${keyReturnMinTime}～${keyReturnMaxTime}の範囲で入力してください。`;
        if (targetDatetime.isBefore(openTime) ||
            targetDatetime.isAfter(closeTime)) {
            return msgOutOfRange;
        }
    }
    return null;
};
export function kaiyakuKeyReturnYmdRangeKojin(vm, kaiyakuForInput, isBeforeTodayMessage, isAfterKaiyakuYmdMessage) {
    return {
        vm: vm,
        kaiyakuForInput: kaiyakuForInput,
        isBeforeTodayMessage: isBeforeTodayMessage,
        isAfterKaiyakuYmdMessage: isAfterKaiyakuYmdMessage
    };
}
/** 鍵返却予定数が活性状態の場合にのみ最大文字数チェック */
validate.validators.numberOfReturnKeysPresence = function (value, options, key, attributes) {
    // 鍵返却予定数が活性状態の場合にのみバリデーション
    const dateFormatKeyReturnNameKbs = [KeyReturnNameKb.PreferredAttendanceDatetime, KeyReturnNameKb.KeyEnvelopePostingDate, KeyReturnNameKb.KeyReturnScheduledDatetime];
    const keyReturnNameKb = options.kaiyakuForInput?.keyReturnNameKb;
    if (dateFormatKeyReturnNameKbs.includes(keyReturnNameKb)) {
        return validate.validators.presence(value, {
            allowEmpty: false,
            message: options.message
        });
    }
    return null;
};
export function numberOfReturnKeysPresence(vm, kaiyakuForInput, message) {
    return {
        vm: vm,
        kaiyakuForInput: kaiyakuForInput,
        message: message
    };
}
/** 鍵返却予定数が活性状態の場合にのみ最大文字数チェック */
validate.validators.numberOfReturnKeysRangeKojin = function (value, options, key, attributes) {
    // 鍵返却予定数が活性状態の場合にのみバリデーション
    const dateFormatKeyReturnNameKbs = [KeyReturnNameKb.PreferredAttendanceDatetime, KeyReturnNameKb.KeyEnvelopePostingDate, KeyReturnNameKb.KeyReturnScheduledDatetime];
    const keyReturnNameKb = options.kaiyakuForInput?.keyReturnNameKb;
    if (dateFormatKeyReturnNameKbs.includes(keyReturnNameKb)) {
        return validate.validators.range(value, range(options.minimum, options.maximum)); // 既存のrange
    }
    return null;
};
export function numberOfReturnKeysRangeKojin(vm, kaiyakuForInput, minimum, maximum) {
    return {
        vm: vm,
        kaiyakuForInput: kaiyakuForInput,
        minimum: minimum,
        maximum: maximum
    };
}
/** 退去立会区分が活性状態の場合にのみ最大文字数チェック */
validate.validators.taikyoTachiaiKbPresence = function (value, options, key, attributes) {
    // 鍵返却予定数が活性状態の場合にのみバリデーション
    const keyReturnNameKb = options.kaiyakuForInput.keyReturnNameKb;
    if (keyReturnNameKb === KeyReturnNameKb.PreferredAttendanceDatetime) {
        return validate.validators.presence(value, {
            allowEmpty: false,
            message: options.message
        });
    }
    return null;
};
export function taikyoTachiaiKbPresence(vm, kaiyakuForInput, message) {
    return {
        vm: vm,
        kaiyakuForInput: kaiyakuForInput,
        message: message
    };
}
/** 退去立会区分が活性状態の場合にのみ最大文字数チェック */
validate.validators.taikyoTachiaiNamePresence = function (value, options, key, attributes) {
    // 鍵返却予定数が活性状態の場合にのみバリデーション
    const keyReturnNameKb = options.kaiyakuForInput.keyReturnNameKb;
    if (keyReturnNameKb === KeyReturnNameKb.PreferredAttendanceDatetime) {
        return validate.validators.presence(value, {
            allowEmpty: false,
            message: options.message
        });
    }
    return null;
};
export function taikyoTachiaiNamePresence(vm, kaiyakuForInput, message) {
    return {
        vm: vm,
        kaiyakuForInput: kaiyakuForInput,
        message: message
    };
}
/** 退去立会名が活性状態の場合にのみフォーマットチェック */
validate.validators.taikyoTachiaiNameFormatKojin = function (value, options, key, attributes) {
    const keyReturnNameKb = options.kaiyakuForInput.keyReturnNameKb;
    if (keyReturnNameKb === KeyReturnNameKb.PreferredAttendanceDatetime) {
        return validate.validators.format(value, regExpInvalidCharPattern());
    }
    return null;
};
export function taikyoTachiaiNameFormatKojin(vm, kaiyakuForInput) {
    return {
        vm: vm,
        kaiyakuForInput: kaiyakuForInput
    };
}
/** 退去立会名が活性状態の場合にのみ最大文字数チェック */
validate.validators.taikyoTachiaiNameMaxLengthKojin = function (value, options, key, attributes) {
    // 退去立会名が活性状態の場合にのみバリデーション
    const keyReturnNameKb = options.kaiyakuForInput.keyReturnNameKb;
    if (keyReturnNameKb === KeyReturnNameKb.PreferredAttendanceDatetime) {
        return validate.validators.length(value, maxLength(options.maximum));
    }
    return null;
};
export function taikyoTachiaiNameMaxLengthKojin(vm, kaiyakuForInput, maximum) {
    return {
        vm: vm,
        kaiyakuForInput: kaiyakuForInput,
        maximum: maximum
    };
}
/** 返金先口座番号のフォーマットチェック */
validate.validators.henkinKouzaNoFormat = function (value, options, key, attributes) {
    const kouzaNoPattern = new RegExp(/^\d{7}$/);
    const irregKouzaNo = new RegExp(/^(?!0{7}$)\d{7}$/);
    if (!RegExp(kouzaNoPattern).test(value)) {
        return validate.validators.format(value, {
            pattern: kouzaNoPattern,
            message: options.kouzaNoFormat
        });
    }
    if (!RegExp(irregKouzaNo).test(value)) {
        return validate.validators.format(value, {
            pattern: irregKouzaNo,
            message: options.irregKouzaNoFormat
        });
    }
    return null;
};
export function henkinKouzaNoFormat(vm, kouzaNoFormat, irregKouzaNoFormat) {
    return {
        vm: vm,
        kouzaNoFormat: kouzaNoFormat,
        irregKouzaNoFormat: irregKouzaNoFormat
    };
}
/** 破損情報のカスタムバリデーション */
validate.validators.hasonInfoValidate = function (value, options, key, attributes) {
    const hasonInfo = options.hasonInfo;
    // 破損なしが選択されている場合は有効
    if (hasonInfo.isNothing) {
        return null;
    }
    let anySelected = false;
    // 破損項目のチェック
    for (const hason of hasonInfo.hasonList) {
        if (hason.isSelected) {
            anySelected = true;
            // S君契約でない場合は箇所の選択をチェック
            if (hasonInfo.sKeiyakuKb === 0) {
                const anyChecked = hason.checkedArray.some(check => check.isChecked);
                if (!anyChecked) {
                    return options.message;
                }
            }
        }
    }
    // 何も選択されていない場合はエラー
    if (!anySelected) {
        // 記入スペースに何か入力されているかチェック
        const hasRemarks = hasonInfo.remarks && hasonInfo.remarks.trim().length > 0;
        if (!hasRemarks) {
            return options.message;
        }
    }
    return null;
};
export function hasonInfoValidate(hasonInfo, message) {
    return {
        hasonInfo: hasonInfo,
        message: message
    };
}
